import allSales               from '@/components/frontOffice/AllSales.vue'

const menuId = 'bo3'
const routes = [
        
    {
        path        : '/allSales', 
        component   : allSales,
        name        : 'salesDDT',
        meta        : { name : 'DDT di vendita', visible : true ,icon : 'fas fa-file-alt',menu:menuId,color:'#ffbf00' },   
    },
  

    
]
export default routes